import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Select } from 'src/app/shared/models/select';

@Component({
  selector: 'app-cambiar-fecha-bd-presupuesto',
  templateUrl: './cambiar-fecha-bd-presupuesto.component.html',
  styleUrls: ['./cambiar-fecha-bd-presupuesto.component.css']
})
export class CambiarFechaBdPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  meses: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  mesBaseDatos: string | null;
  anioBaseDatos: string | null;
  listAnios: Select[] = [];
  listMeses: Select[] = [];
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogCambiarFechaBdPresupuestoRef: MatDialogRef<CambiarFechaBdPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit() {
    this.loadYears();
    let mes = (localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) != null ? localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) : (new Date().getMonth() + 1));
    this.mesBaseDatos = mes != null && Number(mes) < 10 ? '0'.concat(String(mes)) : String(mes);
    this.anioBaseDatos = (localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) != null ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : String(new Date().getFullYear()));
  }

  cambiarFechaBdForm = new FormGroup({
    nuevoMes: new FormControl({ value: '', disabled: true }, [Validators.required]),
    nuevoAnio: new FormControl('', [Validators.required]),
  });

  onSubmit(valuesForm: any): void {
    if (this.cambiarFechaBdForm.invalid) {
      return;
    } else {
      return this.confirm(valuesForm);
    }
  }

  confirm(valuesForm: any) {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_DATEDATA, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        localStorage.setItem(Constanst.STORAGE_DATA_MONTHCONSULT, valuesForm.nuevoMes);
        localStorage.setItem(Constanst.STORAGE_DATA_ANIOCONSULT, valuesForm.nuevoAnio);
        const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_DATEDATA_CHANGED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
        dialog.afterClosed().subscribe(() => {
          this.helperClassService.notifierNewChangeBudget.emit('changedDate');
          this.closeDialogCambiarFechaBdPresupuesto();
        });
      } else {
        dialog.close(false);
      }
    });
  }

  loadYears() {
    this.route = '/getLoadedYears';
    this.method = 'POST';
    this.apiCallService.call$(null, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            let listYears = response.data;
            for (let i = 0; i < listYears.length; i++) {
              let data = listYears[i];
              if (data.loaded) {
                let anio: Select = { id: '', value: '' };
                anio.id = data.year;
                anio.value = data.year;
                this.listAnios.push(anio);
              }
            }
            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        },
        error => {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        });
  }

  rangeMonth(anioSelect: string) {
    this.listMeses = [];
    this.route = '/getLoadedMonth';
    this.method = 'POST';
    let data = {
      year: anioSelect,
    }
    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          //console.log(response);
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            let listMonths = response.data;
            for (let i = 0; i < listMonths.length; i++) {
              let data = listMonths[i];
              let mes: Select = { id: '', value: '' };
              mes.id = data.toString();
              mes.value = this.meses[(data - 1)];
              this.listMeses.push(mes);
            }
            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        },
        error => {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        });

    if (this.listMeses.length > 0) {
      this.listMeses.sort((a, b) => {
        return Number(a.id) - Number(b.id);
      });
    }
  }

  loadMonths(anioUser: string) {
    this.cambiarFechaBdForm.controls['nuevoMes'].disabled;
    this.rangeMonth(anioUser);
    this.cambiarFechaBdForm.controls['nuevoMes'].enable();
  }

  closeDialogCambiarFechaBdPresupuesto() {
    this.dialogCambiarFechaBdPresupuestoRef.close();
  }

}
